import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'church',
      d: 'M-1,-12.5h1v0.5h-1zM-1.5,-12h1.5v0.5h-1.5zM-1,-11.5h0.5v0.5h-0.5zM-3,-3.5h1.5v3.5h-1.5zM-2,0h1v0.5h-1zM-1,0.5h1v0.5h-1z',
    },
    {
      paint: [
        ['church', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1.5,-8.5h0.5v0.5h-0.5zM1,-8.5h0.5v0.5h-0.5zM0,-8h1.5v1h-1.5zM-1.5,-7h0.5v0.5h-0.5zM-0.5,-7h2v1h-2zM0,-6h1v3h-1zM-3,-4h0.5v0.5h-0.5zM2,-3.5h1v1.5h-1zM0,-3h1.5v0.5h-1.5zM-0.5,-2.5h2v0.5h-2zM-1.5,-2h0.5v2h-0.5zM0,-2h3v2h-3zM-1,0h3v0.5h-3zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M-0.5,-11h0.5v0.5h-0.5zM-1.5,-10.5h1.5v0.5h-1.5zM-1.5,-10h2v0.5h-2zM-2,-9.5h3v0.5h-3zM-2,-9h3.5v0.5h-3.5zM-0.5,-8.5h1v0.5h-1zM1.5,-6h0.5v0.5h-0.5zM1.5,-5.5h1v0.5h-1zM1.5,-5h1.5v0.5h-1.5zM1.5,-4.5h1v0.5h-1zM3,-4.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1,-11h0.5v0.5h-0.5zM-1,-8.5h0.5v0.5h-0.5zM0.5,-8.5h0.5v0.5h-0.5zM-2,-6.5h0.5v0.5h-0.5zM-2.5,-6h1v0.5h-1zM1,-6h0.5v3h-0.5zM-3,-5.5h1.5v1h-1.5zM-3.5,-4.5h2v0.5h-2zM2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h1v0.5h-1z',
    },
    {
      paint: [
        ['church', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-8.5h0.5v0.5h-0.5zM-2,-8h2v1h-2zM-2,-7h0.5v0.5h-0.5zM-1.5,-6.5h0.5v0.5h-0.5zM-1.5,-6h1.5v3.5h-1.5zM-1.5,-2.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1,-2.5h0.5v0.5h-0.5zM-1,-2h1v2h-1z' },
    {
      paint: 'cathedralWindow',
      d: 'M-1,-7h0.5v1h-0.5zM1.5,-4h1.5v0.5h-1.5zM1.5,-3.5h0.5v1.5h-0.5z',
    },
  ],
  pixels: 217,
};
const variant1: PixelSprite = {
  layers: [
    { paint: 'church', d: 'M-3,-3.5h1.5v3.5h-1.5zM-2,0h1v0.5h-1zM-1,0.5h1v0.5h-1z' },
    {
      paint: [
        ['church', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M1,-8.5h0.5v0.5h-0.5zM-1,-8h0.5v0.5h-0.5zM0,-8h1.5v0.5h-1.5zM-1.5,-7.5h0.5v1.5h-0.5zM-0.5,-7.5h2v0.5h-2zM0,-7h1.5v1h-1.5zM0,-6h1v3h-1zM-3,-4h0.5v0.5h-0.5zM2,-3.5h1v1.5h-1zM0,-3h1.5v0.5h-1.5zM-0.5,-2.5h2v0.5h-2zM-1.5,-2h0.5v2h-0.5zM0,-2h3v2h-3zM-1,0h3v0.5h-3zM0,0.5h1v0.5h-1z',
    },
    {
      paint: 'roofA',
      d: 'M-1,-10.5h1.5v0.5h-1.5zM-0.5,-10h1.5v1h-1.5zM0,-9h1.5v0.5h-1.5zM1.5,-6h0.5v0.5h-0.5zM1.5,-5.5h1v0.5h-1zM1.5,-5h1.5v0.5h-1.5zM1.5,-4.5h1v0.5h-1zM3,-4.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M0,-8.5h1v0.5h-1zM-2,-6.5h0.5v0.5h-0.5zM-2.5,-6h1v0.5h-1zM1,-6h0.5v3h-0.5zM-3,-5.5h1.5v1h-1.5zM-3.5,-4.5h2v0.5h-2zM2.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h1v0.5h-1z',
    },
    {
      paint: [
        ['church', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-1.5,-9h0.5v0.5h-0.5zM-2,-8.5h2v0.5h-2zM-2,-8h1v0.5h-1zM-0.5,-8h0.5v0.5h-0.5zM-2,-7.5h0.5v1h-0.5zM-1.5,-6h1.5v3.5h-1.5zM-1.5,-2.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1,-2.5h0.5v0.5h-0.5zM-1,-2h1v2h-1z' },
    { paint: 'shadow', d: 'M-1,-7.5h0.5v0.5h-0.5zM-0.5,-7h0.5v1h-0.5z' },
    { paint: 'wheat', d: 'M-1,-7h0.5v1h-0.5z' },
    { paint: 'cathedralWindow', d: 'M1.5,-4h1.5v0.5h-1.5zM1.5,-3.5h0.5v1.5h-0.5z' },
  ],
  pixels: 202,
};
const variant2: PixelSprite = {
  layers: [
    {
      paint: [
        ['church', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-3,-2.5h1v2h-1zM-1,-2h1v0.5h-1zM-0.5,-1.5h1v2h-1zM-2.5,-0.5h0.5v0.5h-0.5zM0,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['church', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M-1.5,-5h0.5v0.5h-0.5zM2,-3h0.5v0.5h-0.5zM-2,-2.5h0.5v2.5h-0.5zM1,-2.5h1.5v0.5h-1.5zM0,-2h2.5v0.5h-2.5zM-1,-1.5h0.5v2h-0.5zM0.5,-1.5h2v1.5h-2zM0.5,0h1.5v0.5h-1.5zM0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'roofA',
      d: 'M-0.5,-5.5h1.5v0.5h-1.5zM-1,-5h2.5v0.5h-2.5zM-1,-4.5h3v0.5h-3zM-1,-4h3.5v0.5h-3.5zM-0.5,-3.5h3.5v0.5h-3.5zM0,-3h1.5v0.5h-1.5zM0,-2.5h0.5v0.5h-0.5z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-2,-4.5h1v0.5h-1zM-2.5,-4h1.5v0.5h-1.5zM-3,-3.5h1.5v0.5h-1.5zM-1,-3.5h0.5v0.5h-0.5zM-3,-3h3v0.5h-3zM1.5,-3h0.5v0.5h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM0.5,-2.5h0.5v0.5h-0.5z',
    },
    { paint: 'trunk', d: 'M-1.5,-2h0.5v2.5h-0.5z' },
    {
      paint: 'church',
      d: 'M-2,-6.5h1v0.5h-1zM-2,-6h1.5v0.5h-1.5zM-2,-5.5h1v0.5h-1zM-2,-5h0.5v0.5h-0.5z',
    },
    { paint: 'cathedralWindow', d: 'M-1.5,-3.5h0.5v0.5h-0.5z' },
  ],
  pixels: 121,
};
export const sprites: readonly PixelSprite[] = [variant0, variant1, variant2];
